import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';
import { IzIntegrationWebComponentSchema } from '../types';

export class IzIntegrationBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<IzIntegrationWebComponentSchema> {
    return {} as unknown as IzIntegrationWebComponentSchema;
  }
}
